import { render, staticRenderFns } from "./commissioni.vue?vue&type=template&id=1c1ff287&"
import script from "./commissioni.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioni.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports